import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { count } from "console";
import {Observable, of} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import { ServerType } from "./app-init.service";
import { RestApiService } from "./rest-api.service";

export interface ShipmentPrices {
  country: string;
  firstBoundary: number;
  highPrice: number;
  lastUpdateTime?: number;
  lowPrice: number;
  middlePrice: number;
  secondBoundary: number;
}

@Injectable({
  providedIn: "root",
})
export class AddressService {
  constructor(
    private restApiService: RestApiService,
    private translate: TranslateService
  ) {}

  endpoint = "address/";
  pickupEndpoint = "pickup-point/all";

  getCountryList() {
    return this.getCountryListByLanguage(this.translate.currentLang);
  }

  getCountryListByLanguage(langCode: string) {
    return this.restApiService.get(
      ServerType.USER,
      this.endpoint + "country-names/" + langCode
    );
  }

  getStateList(country: string) {
    if (!country || country.length == 0) return of([]);
    return this.restApiService.get(
      ServerType.USER,
      this.endpoint + "states/" + country
    );
  }

  getCityList(country: string, state: string) {
    if (country.length == 0 || state.length == 0) return of([]);
    return this.restApiService.get(
      ServerType.USER,
      this.endpoint + "cities/" + country + "/" + state
    );
  }

  getPickupPoints() {
    return this.restApiService.get(ServerType.SHIPMENT, this.pickupEndpoint);
  }

  getShipmentPrices(): Observable<ShipmentPrices[]> {
    return this.restApiService.get(ServerType.CONFIGURATION, "conf/get-shipment-prices");
  }

  getCountryListForCargo() {
    return this.getShipmentPrices().pipe(
      switchMap(shipmentPrices => {
        return this.getCountryList().pipe(
          map(countries => countries.filter(c =>
            shipmentPrices.find(s => s.country.toLowerCase() === c.englishName.toLowerCase())))
        );
      })
    );
  }
}
